/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {CommonModule} from '@angular/common';
// import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, LOCALE_ID} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';

import {
    NbChatModule,
    NbDatepickerModule,
    NbDialogModule,
    NbMenuModule,
    NbSidebarModule,
    NbToastrModule,
    NbWindowModule,
    NbAlertModule,
    //    NbAlertModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule,
    NbIconModule,
} from '@nebular/theme';

import {NbAuthModule} from '@nebular/auth';

// IMPORTACIONES PROPIAS-------------
// import { Globals } from 'globals.ts';
import {AngularFontAwesomeModule} from 'angular-font-awesome';

import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);

// SERVICIOS
import {SERVICES} from './services/';

// modulos para login
import {RecaptchaModule, RecaptchaFormsModule} from 'ng-recaptcha';

// componente de login
import {NgxLoginComponent} from './auth/login/login.component'; // <---

// servicios de login
import * as auth_s from './auth/services';

// modulo de login
// import {NgxAuthModule} from './auth/auth.module';

@NgModule({
    declarations: [AppComponent, NgxLoginComponent],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        ThemeModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        NbChatModule.forRoot({
            messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
        }), 
        NbAlertModule,
        CoreModule.forRoot(),
        AngularFontAwesomeModule,


        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        NbIconModule,
        //    NgxAuthRoutingModule,
        RecaptchaModule.forRoot(), // Keep in mind the "forRoot"-magic nuanc        es!
        RecaptchaFormsModule, // if you need forms support
        NbAuthModule,


    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'es-*'},
        ...SERVICES,
        ...auth_s.SERVICES,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
